import {
  observable,
  action,
  toJS
} from 'mobx';
import {
  message
} from 'antd';
import sortBy from 'lodash/sortBy';
import base from '../../tool/base';
import util from '../../util/index';
const {
  catchApiError,
  getAccessToken
} = util;

const initSearchParams = {
  tmType: 'all',
  tmStatus: 'all',
  beta: 'all',
  name: '',
};
export class AppOrderStore {
  constructor(routing) {
    this.routing = routing;
  }

  @observable orderListInit = [];
  @observable orderList = [];
  @observable loading = false;
  @observable customerList = {};
  @observable customerListData = [];
  @observable customerCount = 0;
  @observable loadingRes = false;
  @observable selectedOrderKey = '';
  @observable loadingApply = false;
  @observable searchParams = initSearchParams;
  @observable pageSize = 10;
  @observable pageNum = 1;
  @observable selectedRowKeys = [];
  @observable selectedRows = [];

  @action
  init = () => {
    this.searchParams = initSearchParams;
    this.orderList = [];
    this.orderListInit = [];
    this.customerList = {};
    this.customerListData = [];
    this.customerCount = 0;
    this.selectedOrderKey = '';
    this.pageSize = 10;
    this.pageNum = 1;
    this.selectedRowKeys = [];
    this.selectedRows = [];
  }

  @action
  setMobxState = (params = {}) => {
    Object.keys(params).forEach(v => {
      this[v] = params[v];
    });
  }

  @action
  setSearchParams = (params = {}) => {
    this.searchParams = {
      ...toJS(this.searchParams),
      ...params,
    }
  }

  @action
  resetSearchParams = () => {
    this.searchParams = initSearchParams;
  }

  @action
  buyV2 = (params = {}) => {
    this.loading = true;
    this.loadingRes = true;
    const param = {
      ...params,
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi('/v1/buyV2', 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
        if (data.status === 'true') {
          const datas = sortBy(data.list, (o) => (o.c_id));
          this.orderList = datas;
          this.orderListInit = datas;
          const id = datas && datas.length > 0 ? datas[0].c_id : '';
          if (id) {
            this.selectedOrderKey = id;
            this.getCustomer({
              id,
            });
          }
        } else {
          message.error(data.msg);
        }
        this.loading = false;
        resolve(data);
      });
    });
  }
  // @action
  // getMould = (id) => {
  //   if (id === 'mode') return 'ea393802-8f4a-4ef0-a4e2-6fe4915cb8c7';
  //   else if (id === 'dev') return 'c2ad5184-3e3e-431f-947e-67ae3a960b59';
  //   else if (id === 'nStandard') return '5058eb5e-8087-4c0d-8a64-3fa600862c02';
  //   else if (id === 'theme') return '8f16dc55-7b76-4786-97a8-8b9ecd0da935';
  //   return '';
  // }
  @action
  getCustomer = (params = {}) => {
    // const id = window.location.hash.split('=').reverse()[0];
    // const moduleType = this.getMould(id);
    this.loadingRes = true;
    const param = {
      access_token: getAccessToken(),
      pageSize: params.pageSize || this.pageSize,
      pageNum: params.pageNum || this.pageNum,
    };
    return new Promise(resolve => {
      base.callApi(`/v1/Customer/${params.id}`, 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
        if (data.status === 'true') {
          this.customerList = this.classifyData(data.List || []);
          this.customerListData = data.List || [];
          this.customerCount = data.Count;
        } else {
          message.error(data.msg);
        }
        this.loadingRes = false;
        resolve(data);
      });
    });
  }

  @action
  classifyData = (data) => {
    const res = {};
    data.forEach(v => {
      const key = v.m_license;
      if (Object.keys(res).indexOf(key) >= 0) res[key].datas.push(v);
      else res[key] = {
        name: v.c_name,
        license: v.m_license,
        datas: [v],
        selectedRowKeys: [],
        selectedRows: []
      };
    });
    return res;
  }

  @action
  setCustomerList = (license, selectedRowKeys, selectedRows) => {
    const datas = toJS(this.customerList);
    Object.keys(datas).forEach(v => {
      if (v === license) {
        datas[v].selectedRowKeys = selectedRowKeys;
        datas[v].selectedRows = selectedRows;
      }
    });
    this.customerList = datas;
  }

  @action
  getApply = (sNumber, sName, tmId) => {
    this.loadingApply = true;
    this.appApplyDatas = {};
    const param = {
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi(`/v1/order/${tmId}`, 'GET', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => {
        if (data.status === 'false') {
          message.error(data.msg);
        } else {
          this.appApplyDatas = {
            ...data,
            sNumber,
            sName,
          };
        }
        this.loadingApply = false;
        resolve(data);
      });
    });
  }

  @action
  filterCustomerList = () => {
    const {
      name,
      beta,
      tmStatus,
      tmType
    } = toJS(this.searchParams);
    const datas = toJS(this.customerListData).filter(v => {
      if (name !== '' && v.c_name.indexOf(name) < 0) return false;
      if (tmType !== 'all' && v.tm_type !== tmType) return false;
      if (tmStatus !== 'all' && v.tm_status !== tmStatus) return false;
      if (beta !== 'all' && v.tm_beta !== beta) return false;
      return true;
    });
    this.customerList = this.classifyData(datas);
  }
}


// WEBPACK FOOTER //
// ./src/stores/order/AppOrderStore.js